import React from 'react';
import { flexRender, HeaderGroup } from '@tanstack/react-table';
import { CaretDown, CaretUp } from '@carbon/react/icons';
import { ColumnFilter } from './column-filter';
import styles from './tanstack-table-styles.module.scss';
import { emptyPinStyleGenerator } from './table-utils';

interface TableHeaderProps {
  headerGroups: HeaderGroup<any>[];
  isColumnFilterActive: boolean;
}

export function TableHeader({
  headerGroups,
  isColumnFilterActive,
}: TableHeaderProps) {
  return (
    <thead>
      {headerGroups.map((headerGroup) => (
        <React.Fragment key={headerGroup.id}>
          <tr>
            {headerGroup.headers.map((header: any) => (
              <th
                key={header.id}
                style={{
                  width: header.getSize(),
                }}
                colSpan={header.colSpan}
              >
                <div
                  className={styles.headerCell}
                  onClick={header.column.getToggleSortingHandler()}
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                  {header.column.getIsSorted() && (
                    <span className={styles.sortIcon}>
                      {header.column.getIsSorted() === 'asc' ? (
                        <CaretUp />
                      ) : (
                        <CaretDown />
                      )}
                    </span>
                  )}
                </div>
                {header.column.getCanResize() && (
                  <div
                    onMouseDown={header.getResizeHandler()}
                    onTouchStart={header.getResizeHandler()}
                    className={`${styles.resizer} ${
                      header.column.getIsResizing() ? styles.isResizing : ''
                    }`}
                  />
                )}
              </th>
            ))}
          </tr>

          {isColumnFilterActive && (
            <tr className={styles.filterTableRow}>
              <ColumnFilter
                key={`filter-row-${headerGroup.id}`}
                headers={headerGroup.headers}
                pinStyleGenerator={emptyPinStyleGenerator}
              />
            </tr>
          )}
        </React.Fragment>
      ))}
    </thead>
  );
}
